export enum DocumentNumberToken {
    /**
     * Numer kolejny w całej firmie
     */
    N_ALL = 'N_ALL',
    /**
     * Numer kolejny w danym dniu
     */
    N_DAY = 'N_DAY',
    /**
     * Numer kolejny w danym miesiącu
     */
    N_MONTH = 'N_MONTH',
    /**
     * Numer kolejny w danym roku
     */
    N_YEAR = 'N_YEAR',
    /**
     * Numer kolejny dla danego odbiorcy
     */
    N_BUYER = 'N_BUYER',

    /**
     * Kod kontrahenta
     */
    K_CLIENT = 'K_CLIENT',
    /**
     * Kod pracownika
     */
    K_PERSON = 'K_PERSON',
    /**
     * Kod rynku
     */
    K_MARKET = 'K_MARKET',
    /**
     * Własny kod
     */
    K_CUSTOM = 'K_CUSTOM',

    /**
     * Rok 4-cyfrowo
     */
    D_YYYY = 'D_YYYY',
    /**
     * Rok 2-cyfrowo
     */
    D_YY = 'D_YY',
    /**
     * Rok 1-cyfrowo
     */
    D_Y = 'D_Y',
    /**
     * Miesiąc cyfrowo
     */
    D_MM = 'D_MM',
    /**
     * Dzień
     */
    D_DD = 'D_DD',

    /**
     * Wersja cyfrą
     */
    V_DIGIT = 'V_DIGIT',
    /**
     * Wersja literą
     */
    V_NUMBER = 'V_NUMBER',

    /**
     * Numer porządkowy oferty
     */
    O_NUM = 'O_NUM',
    /**
     * Cały kod oferty
     */
    O_ALL = 'O_ALL',
    /**
     * Numer z ERP
     */
    O_ERP = 'O_ERP',
    /**
     * Wersja oferty cyfrą
     */
    O_V_DIGIT = 'O_V_DIGIT',
    /**
     * Wersja oferty literą
     */
    O_V_NUMBER = 'O_V_NUMBER',

    /**
     * Dowolny tekst
     */
    STRING = 'STRING'
}